/* Info component on the ScenesPage */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Scene.module.css";
import { useCurrentUser } from '../../../contexts/CurrentUserContext';

const InfoNumbers = () => {
  const currentUser = useCurrentUser();

  return (
    <div>
      <Row className="mb-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}>
          <p className={`${styles.Red} text-center`}>SCENES WORKSPACE INFO</p>
          <hr className={`mt-2 mb-0`}/>
          <p className="pt-2" ><span className={`${styles.Red}`}>*</span> The 
          Scenes Workspace is the primary creative work area, with the Scenes containing 
          the <span className={`${styles.Red}`}>core</span> work features.
          </p>
          <p className="pt-2" ><span className={`${styles.Red}`}>*</span> <span className={`${styles.Red}`}>Create</span> Scenes
           then click on a Scene to work in its Breakdown, Characters/BG, Shotlist, Workshop and more.
          </p>
          <p className="pt-2" ><span className={`${styles.Red}`}>*</span> Use the Scene <span className={`${styles.Red}`}>Workshops</span> to 
          design and collaborate on all Production Items. 
          </p>
          <p className="pt-2" ><span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}>Production Tracker</span> to 
            log in-work Items and inform which Scenes Items is being worked in.
          </p>
          <p className="pt-2" ><span className={`${styles.Red}`}>*</span> Upload and view the Script by clicking the Script tab.
          </p>
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Admin" ||
              currentUser?.groups[0]?.name === "Superadmin") && (<>
          <p className={`${styles.SmallInfo} pt-2`}> Important: The Create Scene page contains Info on Scene numbering and adding new Scenes 
          between Scenes.
          </p>
          <p className={`${styles.SmallInfo} pt-2`} >Note: The Freeze Info contains Info for 
            advanced features only available for the Superadmins.
          </p>
          </>
        )}
        <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoNumbers